import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import NewModel from "../../components/Common/newModel";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Tooltip,
} from "reactstrap";

import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import Select from "react-select";
import { makeSelectStyles } from "../../common/selectStyles";

function New() {
  const { id } = useParams();
  const navigate = useNavigate();
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const layout = localStorage.getItem("layoutMode");
  const styles = makeSelectStyles(layout);
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };

  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [modeleData, setModeleData] = useState([]);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => {
    setTooltipOpen(!tooltipOpen);
  };
  const [tooltipOpen1, setTooltipOpen1] = useState(false);

  const toggleTooltip1 = () => {
    setTooltipOpen1(!tooltipOpen1);
  };
  const [tooltipOpen2, setTooltipOpen2] = useState(false);

  const toggleTooltip2 = () => {
    setTooltipOpen2(!tooltipOpen2);
  };
  const [tooltipOpen3, setTooltipOpen3] = useState(false);

  const toggleTooltip3 = () => {
    setTooltipOpen3(!tooltipOpen3);
  };
  const [tooltipOpen4, setTooltipOpen4] = useState(false);

  const toggleTooltip4 = () => {
    setTooltipOpen4(!tooltipOpen4);
  };
  const [tooltipOpen5, setTooltipOpen5] = useState(false);

  const toggleTooltip5 = () => {
    setTooltipOpen5(!tooltipOpen5);
  };
  const [tooltipOpen6, setTooltipOpen6] = useState(false);

  const toggleTooltip6 = () => {
    setTooltipOpen6(!tooltipOpen6);
  };
  const [tooltipOpen7, setTooltipOpen7] = useState(false);

  const toggleTooltip7 = () => {
    setTooltipOpen7(!tooltipOpen7);
  };
  const [tooltipOpen8, setTooltipOpen8] = useState(false);

  const toggleTooltip8 = () => {
    setTooltipOpen8(!tooltipOpen8);
  };
  const [tooltipOpen9, setTooltipOpen9] = useState(false);

  const toggleTooltip9 = () => {
    setTooltipOpen9(!tooltipOpen9);
  };
  const [tooltipOpen10, setTooltipOpen10] = useState(false);

  const toggleTooltip10 = () => {
    setTooltipOpen10(!tooltipOpen10);
  };
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  /*************************   Type Partenaire *******************************/
  const [typePartenaireData, setTypePartenaireData] = useState({ data: [] });
  const [selectedType, setSelectedType] = useState("");
  const [selectedCumul, setSelectedCumul] = useState("");
  const handleCumulChange = (e) => {
    setSelectedCumul(e);
  };
  const [showData, setShowData] = useState("");
  const handleTypeChange = (e) => {
    setSelectedType(e);
  };
  const getType = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/publipostages_investisseurs/types_publipostages`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((type) => {
          setTypePartenaireData(type);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTypeOptions = () => {
    return [
      {
        options: typePartenaireData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const [orientationData, setOrientationData] = useState({ data: [] });

  const getOrientation = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/publipostages_investisseurs/orientations
`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setOrientationData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderOrientationOptions = () => {
    return [
      {
        options: orientationData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const [categoryData, setCategoryData] = useState({ data: [] });
  const getCategory = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/publipostages_investisseurs/natures_investissements
`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setCategoryData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCategoryOptions = () => {
    return [
      {
        options: categoryData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /// Liste balise
  const [listeData, setListeData] = useState("");

  const getListe = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/publipostages/list_tags?type_filtre_id=5`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setListeData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  /******Un fichier par occurence */
  const [selectedFichierParOccurence, setSelectedFichierParOccurence] =
    useState({ value: 1, label: "Oui" });
  const handleFichierParOccurenceChange = (e) => {
    setSelectedFichierParOccurence(e);
  };

  /************************************* Select Oui Non  *********************************/
  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const renderOuiNonOptions = () => {
    return [
      {
        options: OuiNon.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /************************************* Actif *********************************/
  const [selectedActif, setSelectedActif] = useState({
    value: 1,
    label: "Oui",
  });
  const handleActifChange = (e) => {
    setSelectedActif(e);
  };
  /************************************* Original *********************************/
  const [selectedOriginal, setSelectedOriginal] = useState({
    value: 2,
    label: "Non",
  });
  const handleOriginalChange = (e) => {
    setSelectedOriginal(e);
  };
  /************************************* Nom modèle *********************************/
  const [selectedNomMod, setSelectedNomMod] = useState("");
  const handleNomModChange = (e) => {
    setSelectedNomMod(e.target.value);
  };
  /************************************* Fisc *********************************/
  const [selectedFisc, setSelectedFisc] = useState("");
  const handleFiscChange = (e) => {
    setSelectedFisc(e);
  };
  const [selectedListBalise, setSelectedListBalise] = useState("");

  /************************************* Transmission API *********************************/
  const [selectedTransmissionAPI, setSelectedTransmissionAPI] = useState({
    value: 2,
    label: "Non",
  });
  const handleTransmissionAPIChange = (e) => {
    setSelectedTransmissionAPI(e);
  };
  /************************************* Categorie *********************************/
  const [selectedCategorie, setSelectedCategorie] = useState("");
  const handleCategorieChange = (e) => {
    setSelectedCategorie(e);
  };

  /************************************* Balise*********************************/
  const [selectedBalise, setSelectedBalise] = useState("");
  const handleBaliseChange = (e) => {
    setSelectedBalise(e.target.value);
  };
  /************************************* Commentaire *********************************/
  const [selectedCommentaire, setSelectedCommentaire] = useState("");
  const handleCommentaireChange = (e) => {
    setSelectedCommentaire(e.target.value);
  };
  /********************************Champs ********************************/
  const [selectedChamps1, setSelectedChamps1] = useState("");
  const [selectedChamps2, setSelectedChamps2] = useState("");
  const [selectedChamps3, setSelectedChamps3] = useState("");
  const [selectedChamps4, setSelectedChamps4] = useState("");
  const [selectedChamps5, setSelectedChamps5] = useState("");
  const [selectedChamps6, setSelectedChamps6] = useState("");

  const handleChamps1Change = (e) => {
    setSelectedChamps1(e.target.value);
  };

  const handleChamps2Change = (e) => {
    setSelectedChamps2(e.target.value);
  };

  const handleChamps3Change = (e) => {
    setSelectedChamps3(e.target.value);
  };

  const handleChamps4Change = (e) => {
    setSelectedChamps4(e.target.value);
  };

  const handleChamps5Change = (e) => {
    setSelectedChamps5(e.target.value);
  };

  const handleChamps6Change = (e) => {
    setSelectedChamps6(e.target.value);
  };
  /******************************* Images  *****************************************/
  const [selectedImage1, setSelectedImage1] = useState("");
  const [selectedImage2, setSelectedImage2] = useState("");
  const [selectedImage3, setSelectedImage3] = useState("");
  const [selectedImage4, setSelectedImage4] = useState("");

  // Change handlers for image selection
  const handleImage1Change = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      const reader = new FileReader();

      reader.onloadend = function () {
        // Convertir les données du fichier en base64
        const fileData = reader.result.split(",")[1]; // Récupérer la partie base64 des données

        // Créer un objet JSON contenant les données du fichier
        const fileObject = {
          name: newFile.name, // Nom du fichier
          type: newFile.type, // Type MIME du fichier
          size: newFile.size, // Taille du fichier
          data: fileData, // Données du fichier encodées en base64
        };
        setSelectedImage1(fileObject);
      };
      reader.readAsDataURL(newFile);
    } else {
      setSelectedImage1(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  const handleImage2Change = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      const reader = new FileReader();

      reader.onloadend = function () {
        // Convertir les données du fichier en base64
        const fileData = reader.result.split(",")[1]; // Récupérer la partie base64 des données

        // Créer un objet JSON contenant les données du fichier
        const fileObject = {
          name: newFile.name, // Nom du fichier
          type: newFile.type, // Type MIME du fichier
          size: newFile.size, // Taille du fichier
          data: fileData, // Données du fichier encodées en base64
        };
        setSelectedImage2(fileObject);
      };
      reader.readAsDataURL(newFile);
    } else {
      setSelectedImage2(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  const handleImage3Change = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      const reader = new FileReader();

      reader.onloadend = function () {
        // Convertir les données du fichier en base64
        const fileData = reader.result.split(",")[1]; // Récupérer la partie base64 des données

        // Créer un objet JSON contenant les données du fichier
        const fileObject = {
          name: newFile.name, // Nom du fichier
          type: newFile.type, // Type MIME du fichier
          size: newFile.size, // Taille du fichier
          data: fileData, // Données du fichier encodées en base64
        };
        setSelectedImage3(fileObject);
      };
      reader.readAsDataURL(newFile);
    } else {
      setSelectedImage3(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  const handleImage4Change = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      const reader = new FileReader();

      reader.onloadend = function () {
        // Convertir les données du fichier en base64
        const fileData = reader.result.split(",")[1]; // Récupérer la partie base64 des données

        // Créer un objet JSON contenant les données du fichier
        const fileObject = {
          name: newFile.name, // Nom du fichier
          type: newFile.type, // Type MIME du fichier
          size: newFile.size, // Taille du fichier
          data: fileData, // Données du fichier encodées en base64
        };
        setSelectedImage4(fileObject);
      };
      reader.readAsDataURL(newFile);
    } else {
      setSelectedImage4(null);
      console.log("Aucun fichier sélectionné");
    }
  };

  /******************************* HMF Signature électronique *******************************************/
  const [formSignature, setFormSignature] = useState([]);
  const onAddFormSignature = () => {
    const modifiedSignature = [...formSignature];
    modifiedSignature.push({
      index: modifiedSignature.length + 1,
      id: null,
      page_signature: null,
      position_signature: null,
      signataire: null,
    });
    setFormSignature(modifiedSignature);
  };

  const onDeleteFormSignature = (id) => {
    var modifiedSignature = [...formSignature];
    modifiedSignature = modifiedSignature.filter((x) => x["index"] !== id);
    setFormSignature(modifiedSignature);
  };
  const handleInputChange = (index, field, value) => {
    console.log("ID:", index);
    console.log("Field:", field);
    console.log("Value:", value);

    const modifiedSignature = formSignature.map((signature) => {
      if (signature.index === index) {
        return {
          ...signature,
          [field]: value,
        };
      }
      return signature;
    });

    setFormSignature(modifiedSignature);
  };
  /******************************* END HMF Signature électronique *******************************************/

  /******************************* Présentation  *****************************************/

  const [selectedNomGlobal, setSelectedNomGlobal] = useState("");
  const handleNomGlobalChange = (e) => {
    setSelectedNomGlobal(e.target.value);
  };

  const [selectedNomIndividuel, setSelectedNomIndividuel] = useState("");
  const handleNomIndividuelChange = (e) => {
    setSelectedNomIndividuel(e.target.value);
  };

  const [selectedOrientation, setSelectedOrientation] = useState({
    label: "Portrait",
    value: 1,
  });
  const handleOrientationChange = (e) => {
    setSelectedOrientation(e);
  };

  const [selectedMargeHaut, setSelectedMargeHaut] = useState("2");
  const handleMargeHautChange = (e) => {
    setSelectedMargeHaut(e.target.value);
  };

  const [selectedMargeBas, setSelectedMargeBas] = useState("2");
  const handleMargeBasChange = (e) => {
    setSelectedMargeBas(e.target.value);
  };

  const [selectedMargeCote, setSelectedMargeCote] = useState("2");
  const handleMargeCoteChange = (e) => {
    setSelectedMargeCote(e.target.value);
  };

  const [selectedHauteurLigne, setSelectedHauteurLigne] = useState("1");
  const handleHauteurLigneChange = (e) => {
    setSelectedHauteurLigne(e.target.value);
  };

  const [selectedHauteurPied, setSelectedHauteurPied] = useState("");
  const handleHauteurPiedChange = (e) => {
    setSelectedHauteurPied(e.target.value);
  };

  const [selectedLargeur, setSelectedLargeur] = useState("");
  const handleLargeurChange = (e) => {
    setSelectedLargeur(e.target.value);
  };
  /******************************* Contenu *******************************************/
  const [selectedContent, setSelectedContent] = useState("");
  const handleContentChange = (e) => {
    setSelectedContent(e);
    console.log("content: ", e);
  };
  const [selectedHeader, setSelectedHeader] = useState("");
  const handleHeaderChange = (e) => {
    setSelectedHeader(e.target.value);
  };
  const [selectedFooter, setSelectedFooter] = useState("");
  const handleFooterChange = (e) => {
    setSelectedFooter(e.target.value);
  };

  /******************************* Submit Edit *******************************************/
  const handleNavigate = () => {
    localStorage.setItem("key", true);
    navigate(-1);
  };

  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            New Modèles Investisseur
          </NavLink>
        </NavItem>
      </Nav>
    );
  };
  const getShow = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/publipostages_investisseurs/show_a_imprimer?types_publipostage_id=${selectedType?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setShowData(data);
          console.log(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/publipostages_investisseurs/`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            publipostage: {
              id: id,
              header: selectedHeader,
              corps: selectedContent,
              nom: selectedNomMod,
              footer: selectedFooter,
              //   page_size: "Page size",
              nom_sortie: selectedNomIndividuel,
              image_1: selectedImage1,
              image_2: selectedImage2,
              image_3: selectedImage3,
              image_4: selectedImage4,
              orientation_id: selectedOrientation?.value,
              vertical_margin: selectedMargeHaut,
              horizontal_margin: selectedMargeCote,
              fichier_par_investisseur: selectedFichierParOccurence?.value,
              commentaires: selectedCommentaire,
              champ_1: selectedChamps1,
              champ_2: selectedChamps2,
              champ_3: selectedChamps3,
              champ_4: selectedChamps4,
              champ_5: selectedChamps5,
              champ_6: selectedChamps6,
              types_publipostage_id: selectedType?.value,
              hauteur_de_ligne: selectedHauteurLigne,
              natures_investissement_id: selectedCategorie?.value,
              balises_non_nulle_pour_impression: selectedBalise,
              //   cumul_par_investisseur: "Cumul par investisseur",
              actif: selectedActif?.value,
              original: selectedOriginal?.value,
              nom_du_fichier_global: selectedNomGlobal,
              largeur_px: selectedLargeur,
              footer_spacing: selectedHauteurPied,
              footer_margin: selectedMargeBas,
              a_imprimer: selectedFisc?.value,
              transmission_api_cgp: selectedTransmissionAPI?.value,
            },
            publipostage_hmf_signataires: formSignature.map((obj) => {
              delete obj.index;
              return obj;
            }),
          }),
        }
      );

      if (response.ok) {
        console.log("PATCH request successful");
        const responseData = await response.json();
        navigate(`${backUrl}/publipostages_investisseurs/${responseData.id}`);
        // handleNavigate({ key: true });
      } else {
        console.error("PATCH request failed");
        const responseData = await response.json();
        if (responseData && responseData.publipostage_validation) {
          const errors = responseData.publipostage_validation[0];

          toast.error(errors);
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
    }
  };
  return (
    <>
      <React.Fragment>
        <NewModel
          showData={showData?.data}
          getShow={getShow}
          getType={getType}
          getOrientation={getOrientation}
          getCategory={getCategory}
          getListe={getListe}
          listeData={listeData.message}
          handleSubmit={handleSubmit}
          api={"publipostages_investisseurs"}
          backUrl={backUrl}
          CustomNavTabs={CustomNavTabs}
          colStyle={colStyle}
          activeTab={activeTab}
          toggleTooltip={toggleTooltip}
          tooltipOpen={tooltipOpen}
          toggleTooltip1={toggleTooltip1}
          tooltipOpen1={tooltipOpen1}
          toggleTooltip2={toggleTooltip2}
          tooltipOpen2={tooltipOpen2}
          toggleTooltip3={toggleTooltip3}
          toggleTooltip4={toggleTooltip4}
          toggleTooltip5={toggleTooltip5}
          toggleTooltip6={toggleTooltip6}
          toggleTooltip7={toggleTooltip7}
          toggleTooltip8={toggleTooltip8}
          toggleTooltip9={toggleTooltip9}
          toggleTooltip10={toggleTooltip10}
          tooltipOpen3={tooltipOpen3}
          tooltipOpen4={tooltipOpen4}
          tooltipOpen5={tooltipOpen5}
          tooltipOpen6={tooltipOpen6}
          tooltipOpen7={tooltipOpen7}
          tooltipOpen8={tooltipOpen8}
          tooltipOpen9={tooltipOpen9}
          tooltipOpen10={tooltipOpen10}
          Titre={modeleData?.sil}
          TitrePage={"Modèles Investisseur"}
          modelData={modeleData}
          // Rendu
          renderOrientationOptions={renderOrientationOptions}
          renderOuiNonOptions={renderOuiNonOptions}
          renderTypeOptions={renderTypeOptions}
          renderCategorieOptions={renderCategoryOptions}
          // Handlers
          handleActifChange={handleActifChange}
          handleFiscChange={handleFiscChange}
          handleNomModChange={handleNomModChange}
          handleOriginalChange={handleOriginalChange}
          handleTypeChange={handleTypeChange}
          handleTransmissionAPIChange={handleTransmissionAPIChange}
          handleCategorieChange={handleCategorieChange}
          handleBaliseChange={handleBaliseChange}
          handleCommentaireChange={handleCommentaireChange}
          handleChamps1Change={handleChamps1Change}
          handleChamps2Change={handleChamps2Change}
          handleChamps3Change={handleChamps3Change}
          handleChamps4Change={handleChamps4Change}
          handleChamps5Change={handleChamps5Change}
          handleChamps6Change={handleChamps6Change}
          handleHauteurLigneChange={handleHauteurLigneChange}
          handleHauteurPiedChange={handleHauteurPiedChange}
          handleImage1Change={handleImage1Change}
          handleImage2Change={handleImage2Change}
          handleImage3Change={handleImage3Change}
          handleImage4Change={handleImage4Change}
          handleLargeurChange={handleLargeurChange}
          handleMargeBasChange={handleMargeBasChange}
          handleMargeCoteChange={handleMargeCoteChange}
          handleMargeHautChange={handleMargeHautChange}
          handleNomGlobalChange={handleNomGlobalChange}
          handleNomIndividuelChange={handleNomIndividuelChange}
          handleOrientationChange={handleOrientationChange}
          handleCumulChange={handleCumulChange}
          handleFichierParOccurenceChange={handleFichierParOccurenceChange}
          selectedFichierParOccurence={selectedFichierParOccurence}
          // Variables
          selectedCumul={selectedCumul}
          selectedType={selectedType}
          selectedActif={selectedActif}
          selectedFisc={selectedFisc}
          selectedOriginal={selectedOriginal}
          selectedNomMod={selectedNomMod}
          selectedTransmissionAPI={selectedTransmissionAPI}
          selectedCategorie={selectedCategorie}
          selectedBalise={selectedBalise}
          selectedCommentaire={selectedCommentaire}
          selectedChamps1={selectedChamps1}
          selectedChamps2={selectedChamps2}
          selectedChamps3={selectedChamps3}
          selectedChamps4={selectedChamps4}
          selectedChamps5={selectedChamps5}
          selectedChamps6={selectedChamps6}
          selectedImage1={selectedImage1}
          selectedImage2={selectedImage2}
          selectedImage3={selectedImage3}
          selectedImage4={selectedImage4}
          //
          selectedHauteurLigne={selectedHauteurLigne}
          selectedHauteurPied={selectedHauteurPied}
          selectedMargeBas={selectedMargeBas}
          selectedMargeHaut={selectedMargeHaut}
          selectedNomGlobal={selectedNomGlobal}
          selectedNomIndividuel={selectedNomIndividuel}
          selectedOrientation={selectedOrientation}
          selectedMargeCote={selectedMargeCote}
          selectedLargeur={selectedLargeur}
          // Signature
          formSignature={formSignature}
          onAddFormSignature={onAddFormSignature}
          onDeleteFormSignature={onDeleteFormSignature}
          handleInputChange={handleInputChange}
          // Contenu
          selectedContent={selectedContent}
          handleContentChange={handleContentChange}
          selectedHeader={selectedHeader}
          selectedFooter={selectedFooter}
          handleFooterChange={handleFooterChange}
          handleHeaderChange={handleHeaderChange}
        />
      </React.Fragment>
    </>
  );
}

export default New;
